import {
    iconClient,
    iconCalculator,
    iconReportsDefault,
    iconSearch,
    iconReports,
    iconPayment,
    iconindividual,
    icondual,
    iconAddDocsPayment,
    iconWarranty,
    iconHandshake,
    iconFinancies,
    iconConsults,
    iconCreditsMonotoring
} from '../defaultValues';

const data = {
    role_e292ccec0e2447f8ac0842cc7126725c: [
        {
            id: 'credits',
            icon: iconCreditsMonotoring,
            label: 'Solicitudes de crédito',
            subs: [
                {
                    id: 'gogo',
                    icon: iconCreditsMonotoring,
                    label: 'Consultar',
                    to: '/app/credits',
                },
                {
                    id: 'searcRequest',
                    icon: iconSearch,
                    label: 'Buscar',
                    to: '/app/reports/searchRequest',
                },
              
                {
                    id: 'comercialMonotoring',
                    icon: iconConsults,
                    label: 'Seguimiento Comercial',
                    to: '/app/ComercialMonotoring',
                },

            ],
        },
        {
            id: 'simulador-credito',
            icon: iconCalculator,
            label: 'Simulador de Crédito',
            to: '/app/calculator',
            subs: [
                {
                    icon: iconCalculator,
                    label: 'Simulador de Créditos',
                    to: '/app/calculator',
                },
                {
                    icon: iconCalculator,
                    label: 'Calculadora R&R',
                    to: '/app/reports/calculatorRefinancing',
                },
            ],
        },
        {
            id: 'secondmenu',
            icon: iconClient,
            label: 'Clientes',
            to: '/app/clients',
        },
        {
            id: 'cartera',
            icon: iconReportsDefault,
            label: 'Cartera',
            to: '/app/calculator',
            subs: [
                {
                    icon: iconReportsDefault,
                    label: 'Mora',
                    to: '/app/collection/lista',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Par1 & Par30',
                    to: '/app/collection/per1AndPer30',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Comparativo Cartera',
                    to: '/app/collection/per1AndPer30Comparative',
                },
                {
                    id: 'tuberia',
                    icon: iconReportsDefault,
                    label: 'Tuberia',
                    to: '/app/collection/Pipeline',
                },
            ],
        },
    
        {
            id: 'wompi',
            icon: iconFinancies,
            label: 'Wompi',
            to: '/app/WompiExecutive',
        },
        {
            id: 'financialSolutions',
            icon: iconHandshake,
            label: 'Soluciones Financieras',
            to: '/app/financialSolutions/list',
        },
        {
            id: 'cobranza',
            icon: iconPayment,
            label: 'Cobranza',
            to: '/app/calculator',
            subs: [
                {
                    id: 'signautre',
                    icon: icondual,
                    label: 'Consultar',
                    to: '/app/consultPayment',
                },
                {
                    id: 'signautre',
                    icon: iconAddDocsPayment,
                    label: 'Adjuntar',
                    to: '/app/signaturePayment',
                },
                {
                    id: 'payment',
                    icon: iconReportsDefault,
                    label: 'Generar',
                    to: '/app/paymentDocument',
                    subs: [
                        {
                            id: 'payment',
                            icon: iconindividual,
                            label: 'Individual',
                            to: '/app/paymentDocument',
                        },
                        {
                            id: 'signautre',
                            icon: icondual,
                            label: 'Masivo',
                            to: '/app/massivePaymentDocument',
                        },
                    ],
                },
            ],
        },
        {
            id: 'neww',
            icon: iconWarranty,
            label: 'Garantía Vehicular',
            to: '/app/radicationWarranty',
        },
       
        {
            id: 'blankpage',
            icon: iconReports,
            label: 'Reportes',
            to: '/app/reports',
            subs: [
                {
                    icon: iconReportsDefault,
                    label: 'Generales',
                    to: '/app/reports/reportsDisbursement',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Desempeño Ejecutivos',
                    to: '/app/reports/teamPerformanceExecutive',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Comparativo Productividad',
                    to: '/app/reports/productivityComparative',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Comparativo 12 meses',
                    to: '/app/reports/comparative12Months',
                },
            ],
        },
    ],
};
export default data;
